export const text = {
  title: "Support",
  queryPlaceHolder: "Type Here",
  queryLabel: "Write Your Query",
};
